'use strict';

import cfsShortlist from '../../profile/cfs-shortlist';
import analytics from '../../utils/analytics';

const classNames = {
	saveForLater: 'save-for-later',
};

const modifierNames = {
	disabled: 'disabled',
	saved: 'saved'
};

const savedClass = $.getBemClass(classNames.saveForLater, null, modifierNames.saved);
const disabledClass = $.getBemClass(classNames.saveForLater, null, modifierNames.disabled);

const toggleButtonEnablement = ($saveButtons) => {
	const shouldDisableButtons = (cfsShortlist.count() === cfsShortlist.maxItems);
	const eligibleButtons = $saveButtons.not(`.${savedClass}`);

	if (shouldDisableButtons) {
		eligibleButtons.addClass(disabledClass);
	} else {
		eligibleButtons.removeClass(disabledClass);
	}
};

const setSaveForLater = (trackingAction) => {
	const shortlistLimit = cfsShortlist.maxItems;
	const shortlist = cfsShortlist.get();

	const $saveButtons = $.findByBem(classNames.saveForLater);
	$saveButtons.each((index, element) => {
		const $button = $(element);

		const cfsId = $button.closest('[data-parkers-vehicle-id]').data('parkers-vehicle-id');
		const stockId = $button.closest('[data-stock-id]').data('stock-id');

		if (shortlist.indexOf(cfsId) !== -1) {
			$button.addClass(savedClass);
		}

		$button.off('click.saveForLater').on('click.saveForLater', (e) => {
			e.preventDefault();

			if ($button.is(`.${savedClass}`)) {
				cfsShortlist.delete(cfsId);
				$button.removeClass(savedClass);
				analytics.trackEvent('Shortlist Button - Remove Vehicle', trackingAction, stockId);
			} else if (cfsShortlist.count() < shortlistLimit) {
				cfsShortlist.add(cfsId);
				$button.addClass(savedClass);
				analytics.trackEvent('Shortlist Button - Add Vehicle', trackingAction, stockId);
			}

			toggleButtonEnablement($saveButtons);
		});
	});

	toggleButtonEnablement($saveButtons);
};

export default {
	init(trackingAction) {
		setSaveForLater(trackingAction);
	}
}